import React, { useEffect, useMemo, useState } from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import { getUploadedTime } from './utils';
import {
	ColumnWrapper,
	LeftColumn,
	Description,
} from './FileListDownload.styles';
import { ApButtonDanger } from '@alixpartners/ui-components';

const FileLisTable = ({
	normalizedFiles,
	selectedFiles,
	onRowSelected,
	onDelete,
}) => {
	const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
	const gridStyle = useMemo(() => ({ height: '210px' }), []);
	const defaultColDef = useMemo(() => {
		return {
			flex: 1,
			minWidth: 100,
		};
	}, []);
	const [rowData, setRowData] = useState();
	const columnDefs = [
		{
			headerName: 'File Name',
			field: 'fileName',
			headerCheckboxSelection: true,
			checkboxSelection: true,
		},
		{ field: 'date', headerName: 'Date' },
		{ field: 'authorName', headerName: 'Author Name' },
		{
			field: 'downloadUrl',
			headerName: 'Download',
			cellRenderer: params => {
				let eGui = document.createElement('div');
				eGui.innerHTML = `<a href='${params.data.downloadUrl}'
			  target="_blank"
			  download="file.csv"
			  rel="noopener noreferrer"> Download </a>`;
				return eGui;
			},
		},
	];

	useEffect(
		() => {
			const data = normalizedFiles.map(el => {
				return {
					id: el.id,
					fileName: el.fileName,
					date: getUploadedTime(el.date),
					authorName: el.author,
					downloadUrl: el.downloadUrl,
				};
			});
			setRowData(data);
		},
		[normalizedFiles]
	);

	const gridOptions = {
		modules: AllModules,
		rowData,
		columnDefs,
		defaultColDef,
		rowSelection: 'multiple',
		suppressRowClickSelection: true,
		pagination: true,
		paginationPageSize: 5,
		onRowSelected: onRowSelected,
	};

	const fileCount = selectedFiles.length;
	const selectionText =
		selectedFiles.length > 1 ? 'files are selected.' : 'file is selected.';

	return (
		<div style={containerStyle}>
			{selectedFiles.length > 0 && (
				<>
					<ColumnWrapper>
						<LeftColumn>
							<Description>
								<p>
									{fileCount} {selectionText}
								</p>
							</Description>
						</LeftColumn>
						<ApButtonDanger iconName="delete" onClick={onDelete}>
							Delete
						</ApButtonDanger>
					</ColumnWrapper>
				</>
			)}
			<div style={gridStyle} className="ag-theme-balham">
				<AgGridReact {...gridOptions} />
			</div>
		</div>
	);
};

export default FileLisTable;
